export const REQUEST_FOR_UNPROCESSED_DATA_FOR_NEWS_MODERATION = 'REQUEST_FOR_UNPROCESSED_DATA_FOR_NEWS_MODERATION';
export const RESPONSE_OF_UNPROCESSED_DATA_FOR_NEWS_MODERATION = 'RESPONSE_OF_UNPROCESSED_DATA_FOR_NEWS_MODERATION';
export const POST_PROCESSED_NEWS_DATA_TO_SERVER = "POST_PROCESSED_NEWS_DATA_TO_SERVER";
export const RESPONSE_POST_PROCESSED_NEWS_DATA_TO_SERVER = "RESPONSE_POST_PROCESSED_NEWS_DATA_TO_SERVER";

export const requestUnporcessedNewsDataForModeration = (data) => {
    return {
        type: REQUEST_FOR_UNPROCESSED_DATA_FOR_NEWS_MODERATION,
        data
    }
}

export const responseOfUnprocessedNewsData = (data) => {
    return {
        type: RESPONSE_OF_UNPROCESSED_DATA_FOR_NEWS_MODERATION,
        data
    }
}

export const postProcessedNewsDataToServer  = ( data ) => {
    return { 
        type : POST_PROCESSED_NEWS_DATA_TO_SERVER,
        data
    }
}

export const responseOfpostProcessedNewsDataToServer  = ( data ) => {
    return { 
        type : RESPONSE_POST_PROCESSED_NEWS_DATA_TO_SERVER,
        data
    }
}